import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

export interface UploadingFileProps {
  filename: string;
}

export default function UploadingFile({filename}: UploadingFileProps): JSX.Element {
  return (
    <div className="file-row">
      <div className="row">
        <label>
          <div className="col col-sm-8">
            <input type="checkbox" disabled={true} />
            <span className="file-name">{filename}</span>
          </div>
          <div className="col col-sm-4 sequence-progress">
            <div className="progress-percentage-box u-small-spacing-right">
              <span className="progress-percentage-text" />
            </div>
            <div className="progress">
              <div
                style={{width: '0%'}}
                className="progress-bar"
                {...getTestProps({
                  component: 'UploadingFile',
                  element: 'progressBar',
                })}
              />
            </div>
          </div>
        </label>
      </div>
      <div className="row error-row hidden">
        <div className="pull-right close">&times;</div>
        <div className="message" />
      </div>
    </div>
  );
}
